import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { TFunction } from 'react-i18next';
import { Modal, StyleSheet, Text, TouchableOpacity, TouchableWithoutFeedback, View } from 'react-native';

type UserInfoModalProps = {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  deleteCurrentAuthData: () => Promise<void>;
  user: { name: string; email: string };
  t: TFunction<'translation', undefined>;
};

export default function UserInfoModal({ visible, setVisible, deleteCurrentAuthData, user, t }: UserInfoModalProps) {
  const displayName = user.name || user.email;
  const showEmail = user.name && user.email;
  const initialLetter = (user.name?.trim() || user.email?.trim() || 'U')[0];

  return (
    <Modal transparent visible={visible} animationType="fade">
      <TouchableWithoutFeedback onPress={() => setVisible(false)}>
        <View style={styles.overlay}>
          <TouchableWithoutFeedback>
            <View style={styles.card}>
              <View style={styles.userInfo}>
                <View style={styles.avatar}>
                  <Text style={styles.avatarText}>{initialLetter || 'U'}</Text>
                </View>

                <View style={styles.infoCtn}>
                  <Text style={styles.name}>{displayName}</Text>
                  {showEmail && <Text style={styles.email}>{user.email}</Text>}
                </View>
              </View>
              <View style={styles.divider} />
              <TouchableOpacity
                style={styles.logoutButton}
                onPress={async () => {
                  setVisible(false);
                  await deleteCurrentAuthData();
                }}
              >
                <Ionicons name="log-out" size={18} style={{ color: '#e53935' }} />
                <Text style={styles.logoutText}>{t('log-out')}</Text>
              </TouchableOpacity>
            </View>
          </TouchableWithoutFeedback>
        </View>
      </TouchableWithoutFeedback>
    </Modal>
  );
}

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.25)',
  },
  card: {
    position: 'absolute',
    top: 80,
    right: 20,
    width: 260,
    backgroundColor: '#fff',
    borderRadius: 16,
    padding: 16,

    shadowColor: '#000',
    shadowOpacity: 0.15,
    shadowRadius: 10,
    elevation: 10,
  },
  userInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  avatar: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: '#eee',
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatarText: {
    lineHeight: 1,
    fontWeight: 'bold',
    fontSize: 16,
  },
  name: {
    fontSize: 14,
    fontWeight: '600',
  },
  email: {
    fontSize: 12,
    color: '#777',
    marginTop: 2,
  },
  divider: {
    height: 1,
    backgroundColor: '#eee',
    marginVertical: 12,
  },
  logoutButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  logoutText: {
    color: '#e53935',
    fontWeight: '500',
  },
  infoCtn: {
    flex: 1,
  },
});
